import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } };

  submit() {
    this.element.requestSubmit();
  }

  debouncedSubmit() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.submit(), this.delayValue);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }
}
